import { createDateFromAdjustment, createEndOfDay, createStartOfDay, } from "./create.js";
/**
 * Provides a way to obtain the number of days in a specific month of a
 * particular year.
 *
 * @param year The year for which to obtain the number of days in a month.
 * @param month The month for which to obtain the number of days.
 * @returns The number of days in the specified month of the specified year.
 */
export function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
}
/**
 * Calculates the UTC offset caused by daylight savings time between the first
 * date and the second date.
 *
 * @param firstTime The first date.
 * @param secondTime The second date.
 * @returns The UTC offset caused by daylight savings time between the first and
 *   second dates.
 */
export function getDSTOffset(firstTime, secondTime) {
    const firstString = firstTime.toString();
    const secondString = secondTime.toString();
    const isDaylight = (s) => {
        return s.includes("Daylight");
    };
    if (isDaylight(firstString) && isDaylight(secondString)) {
        return 0;
    }
    else if (!isDaylight(firstString) && !isDaylight(secondString)) {
        return 0;
    }
    else if (isDaylight(firstString) && !isDaylight(secondString)) {
        return -60;
    }
    return 60;
}
/**
 * Provides a way to obtain the Date object representing the first day of the
 * current week, with the time portion set to the start of the day.
 *
 * @returns A Date object representing the first day of the current week.
 */
export function getFirstDayOfWeek() {
    const today = getRightNow();
    const raw = createDateFromAdjustment(today, "date", today.getDay() * -1);
    return createStartOfDay(raw);
}
/**
 * Provides a way to obtain the Date object representing the last day of the
 * current week, with the time portion set to the end of the day.
 *
 * @returns A Date object representing the last day of the current week.
 */
export function getLastDayOfWeek() {
    const today = getRightNow();
    const raw = createDateFromAdjustment(today, "date", 6 - today.getDay());
    return createEndOfDay(raw);
}
/**
 * Provides a convenient way to obtain the current date and time as a Date
 * object.
 *
 * @returns A Date object representing the current date and time.
 */
export function getRightNow() {
    return new Date();
}
//# sourceMappingURL=get.js.map